import "./components/formProgram";

document.addEventListener("DOMContentLoaded", function () {
  const mainTabs = document.querySelectorAll(".information-program__tab");
  const mainContents = document.querySelectorAll(
    ".information-program__container"
  );

  mainTabs.forEach((tab, index) => {
    tab.addEventListener("click", function () {
      mainTabs.forEach((t) => t.classList.remove("isActive"));
      mainContents.forEach((c) => c.classList.remove("isActive"));

      tab.classList.add("isActive");
      mainContents[index].classList.add("isActive");
    });
  });

  const subTabGroups = document.querySelectorAll(
    ".information-program__sub-tabs"
  );

  subTabGroups.forEach((group) => {
    const subTabs = group.querySelectorAll(
      ".information-program__sub-tabs--li"
    );
    const subjectSections = group.querySelectorAll(
      ".information-program__sub-tabs--subject--data"
    );

    subTabs.forEach((subTab, index) => {
      subTab.addEventListener("click", function () {
        subTabs.forEach((t) => t.classList.remove("isActive"));
        subjectSections.forEach((s) => (s.style.display = "none"));

        subTab.classList.add("isActive");
        subjectSections[index].style.display = "block";
      });
    });

    if (subjectSections.length > 0) {
      subjectSections.forEach((s) => (s.style.display = "none"));
      subjectSections[0].style.display = "block";
      if (subTabs.length > 0) subTabs[0].classList.add("isActive");
    }
  });

  const titles = document.querySelectorAll(".equivalence-table__title");
  let maxHeight = 0;

  titles.forEach((title) => {
    maxHeight = Math.max(maxHeight, title.offsetHeight);
  });

  titles.forEach((title) => {
    title.style.height = `${maxHeight}px`;
  });
});
